import { render } from "./FinalMessageHouse.vue?vue&type=template&id=5228fa2e&scoped=true"
import script from "./FinalMessageHouse.vue?vue&type=script&lang=js"
export * from "./FinalMessageHouse.vue?vue&type=script&lang=js"

import "./FinalMessageHouse.vue?vue&type=style&index=0&id=5228fa2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5228fa2e"]])

export default __exports__